import { IThirdPartyCalendarsWrite } from '@/types/apiClient/IEventTypeWrite';
import { default as IService } from '@/types/IEventType';
import { Box } from '@chakra-ui/react';
import CalendarsEmpty from './components/CalendarsEmpty/CalendarsEmpty';
import CalendarSyncSection from './components/CalendarSyncSection/CalendarSyncSection';
import ConnectedCalendarList from './components/ConnectedCalendarList/ConnectedCalendarList';
import SecondaryCalendarsToggle from './components/SecondaryCalendarsToggle/SecondaryCalendarsToggle';
import useConnectedCalendars from './useConnectedCalendars';

interface IConnectedCalendarProps {
	isLoading: boolean;
	service: IService;
	onChange: (thirdPartyCalendars: IThirdPartyCalendarsWrite) => void;
}

export default function ConnectedCalendars(props: IConnectedCalendarProps) {
	const { handleChangeRead, handleChangeWrite, handleFilterChange, calendars, isShowingSecondaryCalendars } =
		useConnectedCalendars(props);

	if (props.service.hosts.every((host) => host.calendars.length === 0)) {
		return <CalendarsEmpty />;
	}

	return (
		<Box>
			<ConnectedCalendarList
				hosts={props.service.hosts}
				onChangeRead={handleChangeRead}
				onChangeWrite={handleChangeWrite}
				showSecondaryCalendars={isShowingSecondaryCalendars}
				isLoading={props.isLoading}
			/>
			<CalendarSyncSection />

			<SecondaryCalendarsToggle
				calendars={calendars}
				isChecked={isShowingSecondaryCalendars}
				onChange={handleFilterChange}
			/>
		</Box>
	);
}
